import { gql } from '@apollo/client'

const LABEL_LEGEND_FRAGMENT = gql`
  fragment LabelLegendFragment on LabelLegend {
    id
    label
    highlights {
      dishId
      menuTitleId
      originField
      posIndex
      matchType
      score
    }
    isSuggestedByAi
    conflictResolutionType
    isChoice
    isConfusing
    matchType
    originDishId
    originMenuTitleId
  }
`

export default LABEL_LEGEND_FRAGMENT
